<template>
  <wow-card elevation="0" :show-title="false">
    <v-data-table dense :headers="headers" :items="gapProductList"></v-data-table>
  </wow-card>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import _ from 'lodash'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
export default {
  name: 'viewGap',
  components: {
    WowCard
  },
  props: {
    orderObj: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      headers: [
        { text: 'FCID', value: 'productID', align: 'center', sortable: true },
        { text: 'BOM Quantity', value: 'bomQuantity', align: 'center', sortable: true },
        { text: 'BOQ Quantity', value: 'boqQuantity', align: 'center', sortable: true },
        { text: 'Placed Quantity', value: 'placedQuantity', align: 'center', sortable: true },
        { text: 'Gap Quantity', value: 'gapProductQuantity', align: 'center', sortable: true }
      ],
      gapProductList: []
    }
  },
  async created () {
    await this.getGapOrderDetails()
  },
  methods: {
    getGapOrderDetails: async function () {
      try {
        this.gapProductList = []
        const res = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/get-order-gap-product-list?initiateOrderID=${this.orderObj.id}`)
        if (res.status === 200) {
          if (!_.isArray(res.data)) {
            return this.$dialog.error({
              text: res.data,
              title: 'Error'
            })
          }
          this.gapProductList = res.data
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
  }
}
</script>
